import { styled } from '@mui/material/styles';
import { Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';

const BlueToolTip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: 'var(--main-color)'
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'var(--main-color)',
        border: '1px solid var(--main-color)',
        borderRadius: 8,
        boxShadow: '0px 2px 10px rgba(24, 45, 85, 0.1)',
        minWidth: 293,
        padding: '16px 24px'
    }
}));

export default BlueToolTip;
